import media from '~/utils/media'
import { ready } from '~/core'

ready('foldouts', '.foldouts-foldout', (foldout) => {
  const wrapper = foldout.closest('.foldouts')
  const toggle = foldout.querySelector('.foldouts-foldoutHeader')
  const content = foldout.querySelector('.foldouts-foldoutContent')

  const animate = (el, start, end, parent = true, scroll = false) => {
    console.log('close_siblings')
    el.animate([{ height: `${start}px` }, { height: `${end}px` }], {
      duration: 350,
      easing: 'ease-out',
    })
    if (parent && media.md.matches) {
      start = parseInt(getComputedStyle(wrapper).marginBottom)
      wrapper.animate([{ marginBottom: `${start}px` }, { marginBottom: `${end}px` }], {
        duration: 350,
        easing: 'ease-out',
        fill: 'forwards',
      })
    }
    if (scroll) {
      setTimeout(() => {
        if (isElementInViewport(content)) return
        window.scrollBy({
          top: el.closest('.foldouts-foldoutInner').getBoundingClientRect().top,
          behavior: 'smooth',
        })
      }, 350)
    }
  }

  const close_all = () => {
    console.log('close_siblings')
    let all = [...wrapper.querySelectorAll('.is-open')]
    all.forEach((item) => {
      let content = item.querySelector('.foldouts-foldoutContent')
      let start = content.offsetHeight
      let end = (item.classList.remove('is-open'), content.offsetHeight)

      animate(content, start, end)
    })
  }

  const close_siblings = () => {
    console.log('close_siblings')
    let siblings = [...wrapper.querySelectorAll('.is-open')].filter((sib) => sib != foldout)
    siblings.forEach((sib) => {
      let content = sib.querySelector('.foldouts-foldoutContent')
      let start = content.offsetHeight
      let end = (sib.classList.remove('is-open'), content.offsetHeight)

      animate(content, start, end, false)
    })
  }

  const open = () => {
    console.log('open')
    let start = content.offsetHeight
    let end = (foldout.classList.add('is-open'), content.offsetHeight)
    close_siblings()
    animate(content, start, end, true, true)
  }

  const close = () => {
    let start = content.offsetHeight
    let end = (foldout.classList.remove('is-open'), content.offsetHeight)

    animate(content, start, end)
  }

  toggle.addEventListener('click', () =>(foldout.classList.contains('is-open') ? close_all() : open()))
  toggle.addEventListener('keydown', (e) => {
    const isToggleKey = (e.key === 'Enter' || e.key === ' ');
    const isEscapeKey = e.key === 'Escape';
    const isOpen = foldout.classList.contains('is-open');

    if (isToggleKey || isEscapeKey)
      e.preventDefault();

    if (isToggleKey)
      isOpen ? close_all() : open();
    else if (isEscapeKey)
      close_all();
  })

  // reset menu when we hit the desktop size
  media.md.addListener((e) => close_all)

  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
})
